
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suggested-order",
      function () {
        return require("private-next-pages/suggested-order/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/suggested-order"])
      });
    }
  